
import { IStandardRutinWrapperProps } from '../../../../_StandardRutin/StandardRutin';
import BokforderProviderWrapper from './BokforderProviderWrapper';

const BokforderWrapper: React.FC<
  React.PropsWithChildren<IStandardRutinWrapperProps>
> = props => {
  return <BokforderProviderWrapper>{props.children}</BokforderProviderWrapper>;
};

export default BokforderWrapper;
